import { useRef, useEffect, useState } from "react";
import { Footer, Navbar, NavbarUser } from '../../containers';
import "./impressum.css";
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const Impressum = () => {

    const { t } = useTranslation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    // Footer berechnen
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(0);
    // Navbar berechnen
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [pictureSrc, setPictureSrc] = useState("");

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setIsAuthenticated(!!token);
        // Footer height calculation
        if (footerRef.current) {
            setFooterHeight(footerRef.current.clientHeight);
        }

        // Navbar height calculation
        const navbarElement = document.querySelector('.navbarHomepage');
        if (navbarElement) {
            const navbarHeight = navbarElement.offsetHeight;
            setNavbarHeight(navbarHeight);
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 22; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();

        // Scroll to top on page load
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    return (
        <div className="wrapper-impressum" style={{ backgroundImage: pictureSrc ? `url(${pictureSrc})` : "none", }}>
            {isAuthenticated ? <NavbarUser /> : <Navbar />}
            <div className="impressum-site" id="impressum" style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
                <div className="impressum-content-parent" style={{ marginTop: `${navbarHeight + 1}px` }}>
                    <h1>{t('Imprint')}</h1>
                    <div className="impressum-content-child">
                        <p>
                            <strong>{t('ImprintProviderHeading')}</strong><br />
                            <strong>{t('CompanyName')}</strong> {t('CompanyNameAnswer')}<br />
                            <strong>{t('Representatives')}</strong> {t('RespresentativesAnswer')}<br />
                            <strong>{t('Address')}</strong> {t('AddressAnswer')}<br />
                            <strong>{t('Telephone')}</strong> {t('TelephoneAnswer')}<br />
                            <strong>{t('ImprintEMail')}</strong> {t('EMailAnswer')}<br />
                            <strong>{t('ImprintWebsite')}</strong> www.barmatch.de<br />
                            <strong>{t('USTID')}</strong> {t('ImprintUSTIDAnswer')}<br />
                            <div className="long-content">
                                <strong>{t('LegalNotice')}</strong> <br />
                                &nbsp;
                                <strong>{t('ImprintBusinessRegHeading')}</strong><br />
                                {t('ImprintBusinessRegText')}<br />
                                {t('ImprintBusinessRegAuthority')} <br /> <br />

                                <strong>{t('ImprintContentResponsibleHeading')}</strong><br />
                                {t('ImprintContentResponsibleName')}<br />
                                {t('ImprintContentResponsibleStreet')} <br />
                                {t('ImprintContentResponsibleCity')} <br />
                                <strong>{t('ImprintDisputeResolutionHeading')}</strong><br />
                                {t('ImprintDisputeResolutionText')}<br />
                                {t('ImprintDisputeResolutionLink')}<br />

                                {t('ImprintDisputeResolutionEmailNote')}<br />

                                <strong>{t('ImprintConsumerDisputeHeading')}</strong><br />
                                {t('ImprintConsumerDisputeText')}<br /> <br />

                                <strong>{t('ImprintEventsHeading')}</strong><br />
                                {t('ImprintEventsText')}<br />
                                {t('ImprintEventsMinAge')}<br /> <br />

                                <strong>{t('ImprintPhotoHeading')}</strong><br />
                                {t('ImprintPhotoText1')}<br />
                                {t('ImprintPhotoUsage')}<br />
                                {t('ImprintPhotoUsage1')}<br />
                                {t('ImprintPhotoUsage2')}<br />
                                {t('ImprintPhotoUsage3')}<br />
                                {t('ImprintPhotoUsage4')}<br /> <br />

                                {t('ImprintPhotoNoSale')}<br />
                                {t('ImprintPhotoObjection')}<br /> <br />

                                {t('ImprintPhotoLegalBasis')}<br /> <br />

                                <strong>{t('ImprintGoogleCalHeading')}</strong><br />
                                {t('ImprintGoogleCalText')}<br />
                                {t('ImprintGoogleCalPrivacy')} <br /> <br />

                                <strong>{t('ImprintLiabilityContentHeading')}</strong><br />
                                {t('ImprintLiabilityContentText1')} <br /> <br />

                                {t('ImprintLiabilityContentText2')}<br /> <br />

                                <strong>{t('ImprintLiabilityLinksHeading')}</strong><br />
                                {t('ImprintLiabilityLinksText')}<br /> <br />

                                <strong>{t('ImprintCopyrightHeading')}</strong><br />
                                {t('ImprintCopyrightText')}

                            </div>
                        </p>
                    </div>
                </div>
            </div>
            <div ref={footerRef}>
                <Footer></Footer>
            </div>
        </div>
    );
};

export default Impressum;